module.exports = __webpack_public_path__ + "media/images/cliparts/Desk Computer 7-dddcf694909255d4c88eb633256612b5.svg";